<template>
  <div class="baseAbilityRadioGroup">
    <input
      class="baseAbilityRadioGroup__radio"
      type="radio"
      :value="2"
      :checked="value === 2"
      :disabled="disabled || uneditableAbility"
      @change="handleRadioChange(2)"
    />
    <label class="baseAbilityRadioGroup__label">編輯</label>
    <input
      class="baseAbilityRadioGroup__radio"
      type="radio"
      :value="1"
      :checked="value === 1"
      :disabled="disabled || unreadableAbility"
      @change="handleRadioChange(1)"
    />
    <label class="baseAbilityRadioGroup__label">檢視</label>
    <input
      class="baseAbilityRadioGroup__radio"
      type="radio"
      :value="0"
      :checked="value === 0"
      :disabled="disabled"
      @change="handleRadioChange(0)"
    />
    <label class="baseAbilityRadioGroup__label">禁止</label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    uneditableAbility: {
      type: Boolean,
      required: false,
      default: false,
    },
    unreadableAbility: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleRadioChange(value) {
      this.$emit('handleRadioChange', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.baseAbilityRadioGroup {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &__label {
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 0;
    font-weight: normal;
    &:last-child {
      margin-right: 0;
    }
  }

  &__radio {
    margin-top: 0;
    zoom: 1.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/select/BaseAbilityRadioGroup.vue